import React from 'react';
import Options from '../dashboard/partials/options';
import fakeAuth from '../../../fakeAuth';
import { Link } from 'react-router';
import Gear from '../../partials/gear';
import ScrollAnimation from 'react-animate-on-scroll';
import { Animated } from 'react-animated-css';
import _ from 'lodash';
import request from 'superagent';
import DatePicker from 'react-datepicker';
import CustomDatePicker from '../../partials/datepicker';
import Switch from "react-switch";
import config from '../../../config';
import Medal from '../medals/partials/card';
import moment from 'moment';
import { Popover, PopoverBody, PopoverHeader, } from 'reactstrap';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import "react-datepicker/dist/react-datepicker.css";

class AddTournament extends React.Component {
    state = {
        tournament: null,
        microTransac: false,
        deleting: false,
        medals: null,
        selectedMedal: null,
        isMedalOpen: false,
        seasonTypes: null,
        selectedHotel: null
    }
    componentWillMount() {
        const { tournaments = [], tournamentsActions, medalsActions, affiliatesActions, params, seasonTypes, hotelsActions } = this.props, { id } = params;
        if (id) {
            if (tournaments && tournaments.length && _.find(tournaments, a => parseInt(a.id, 10) === parseInt(id, 10))) {
                this.setState({ seasonTypes, tournament: _.find(tournaments, a => parseInt(a.id, 10) === parseInt(id, 10)) }, () => {
                    this.setNotes();
                });
                tournamentsActions && tournamentsActions.fetch(id);
            } else {
                this.setState({ microTransac: true }, () => {
                    tournamentsActions && tournamentsActions.fetch(id);
                });
            }
        } else {
            this.setState({ tournament: { Rates: [] } }, () => {
                this.setNotes();
            });
            tournamentsActions && tournamentsActions.fetch();
        }
        medalsActions.fetch();
        affiliatesActions.fetch();
        hotelsActions.fetch();
    }
    componentWillReceiveProps = nextProps => {
        const { tournament, medals, affiliates, seasonTypes, hotels } = nextProps;
        this.setState({
            tournament: tournament || this.state.tournament,
            medals,
            affiliates,
            microTransac: false,
            seasonTypes,
            hotels
        }, () => {
            this.setNotes();
        });
    }
    componentWillUnmount() {
        const { tournamentsActions } = this.props;
        tournamentsActions.clearTournament();
    }

    setNotes = () => {
        const { tournament = {} } = this.state;
        if (tournament) {
            if (tournament.Notes && tournament.Notes.length) {
                const contentBlock = htmlToDraft(tournament.Notes);
                if (contentBlock) {
                    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                    const editorState = EditorState.createWithContent(contentState);
                    this.setState({ editorState });
                }
            } else {
                this.setState({ editorState: EditorState.createEmpty() });
            }
        }
    }
    logout = () => fakeAuth.signout(() => { this.props.router.push('/admin'); });

    save = () => {
        const { tournament, selectedMedal, editorState } = this.state, { tournamentsActions } = this.props;
        tournament.Name = this.txtName.value;
        tournament.IdMedal = (selectedMedal || tournament.Medal || {}).id;
        tournament.LocationName = this.txtLocationName.value;
        tournament.LocationCity = this.txtCity.value;
        tournament.LocationState = this.txtState.value;
        tournament.LocationAddress = this.txtLocationAddress.value;
        tournament.LocationZipCode = this.txtZipCode.value;
        tournament.IdSeason = (this.txtIdSeason || {}).value || null;
        tournament.Notes = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        tournament.ESPNDates = this.txtESPNDates.value;
        tournament.GamesForShirt = this.txtGamesForShirt ? (this.txtGamesForShirt.value || 0) : 0;
        if (!tournament.DateEnd) tournament.DateEnd = tournament.DateStart;

        this.setState({ microTransac: true }, () => {
            request[tournament.id ? 'patch' : 'post'](`${config.apiEndpoint}/api/cs/v2/tournaments${tournament.id ? `/${tournament.id}` : ''}`)
                .set('Authorization', `Bearer ${config.apiKey}`)
                .send(tournament)
                .then(({ body }) => {
                    // TODO: Handle any kind of error here
                    if (body.success) {
                        tournamentsActions.fetch();
                        this.props.router.push('/admin/tournaments');
                    } else {
                        this.setState({ microTransac: false });
                    }
                });
        });
    }
    toggleDelete = () => this.setState({ deleting: !this.state.deleting });
    doDelete = () => {
    }
    onDateStart = selectedDateStart => {
        const { tournament } = this.state;
        tournament.DateStart = selectedDateStart.format('YYYY-MM-DD');
        this.setState({ tournament });
    }
    onDateEnd = selectedDateEnd => {
        const { tournament } = this.state;
        tournament.DateEnd = selectedDateEnd.format('YYYY-MM-DD');
        this.setState({ tournament });
    }

    // affiliates
    toggleAffiliates = () => this.setState({ isAffiliatesOpen: !this.state.isAffiliatesOpen });
    selectAffiliates = affiliate => {
        const { tournament } = this.state;
        tournament.IdAffiliate = (affiliate || {}).id;
        this.setState({ tournament, isAffiliatesOpen: false });
    }

    // Season Type
    toggleSeasonType = () => this.setState({ isSeasonTypesOpen: !this.state.isSeasonTypesOpen });
    selectSeasonType = seasonType => {
        const { tournament } = this.state;
        tournament.IdSeasonType = seasonType.id;
        this.setState({ tournament, isSeasonTypesOpen: false });
    }

    // toggles
    toggleIsPublish = () => {
        const { tournament } = this.state;
        tournament.IsPublic = !tournament.IsPublic;
        this.setState({ tournament });
    }
    toggleShowSchedule = () => {
        const { tournament } = this.state;
        tournament.ShowSchedule = !tournament.ShowSchedule;
        this.setState({ tournament });
    }

    toggleShowNotes = () => {
        const { tournament } = this.state;
        tournament.ShowNotes = !tournament.ShowNotes;
        this.setState({ tournament });
    }
    toggleESPN = () => {
        const { tournament } = this.state;
        tournament.IsESPN = !tournament.IsESPN;
        this.setState({ tournament });
    }
    toggleSuspended = () => {
        const { tournament } = this.state;
        tournament.Suspended = !tournament.Suspended;
        this.setState({ tournament });
    }
    toggleShirt = () => {
        const { tournament } = this.state;
        tournament.GivesShirt = !tournament.GivesShirt;
        this.setState({ tournament });
    }


    // medals
    toggleMedal = () => this.setState({ isMedalOpen: !this.state.isMedalOpen });
    selectMedal = selectedMedal => this.setState({ selectedMedal, isMedalOpen: false });

    // rates
    addRate = () => {
        const r = {
            Name: this.txtRateName.value,
            Rate: this.txtRate.value,
            Dates: this.txtRateDates.value
        }, { tournament } = this.state;
        tournament.Rates.push(r);
        this.setState({ tournament });
    }
    deleteRate = index => {
        const { tournament } = this.state;
        tournament.Rates = [...tournament.Rates.slice(0, index), ...tournament.Rates.slice(index + 1)];
        this.setState({ tournament });
    }
    //

    // hotels
    addHotel = () => {
        const r = {
            ..._.pick(this.state.selectedHotel, 'IdHotel', 'HotelName'),
            Rate: this.txtRateHotel.value,
        }, { tournament } = this.state;
        if (!tournament.Hotels) tournament.Hotels = [];
        tournament.Hotels.push(r);
        this.setState({ tournament, selectedHotel: null });
    }
    deleteHotel = index => {
        const { tournament } = this.state;
        tournament.Hotels = [...tournament.Hotels.slice(0, index), ...tournament.Hotels.slice(index + 1)];
        this.setState({ tournament });
    }
    //

    MarkHost = (hotel) => {
        console.log({ hotel });
        request.patch(`${config.apiEndpoint}/api/cs/v2/hotels/host`)
            .set('Authorization', `Bearer ${config.apiKey}`)
            .send(_.pick(hotel, 'IdHotel', 'IdSeason', 'IsHost'))
            .then((data) => {

            });
    }
    toggleDelete = () => this.setState({ deleting: !this.state.deleting });
    doDelete = () => {
        const { tournament } = this.state, { tournamentsActions } = this.props;
        this.setState({ microTransac: true }, () => {

            request.del(`${config.apiEndpoint}/api/cs/v2/tournaments/${tournament.id}`)
                .set('Authorization', `Bearer ${config.apiKey}`)
                .then((data) => {
                    // TODO: Handle any kind of error here
                    if (data.body.success) {
                        tournamentsActions.fetch();
                        this.props.router.push('/admin/tournaments');
                    } else {
                        alert('ERROR')
                        console.log(data.body);
                        this.setState({ microTransac: false });
                    }
                });
        });
    }

    onEditorStateChange = editorState => this.setState({ editorState });

    render() {
        const { tournament = {}, microTransac, medals = [], affiliates = [], selectedMedal, seasonTypes, editorState, hotels } = this.state;

        return (
            <section className="d-flex flex-column h-100">
                <div className="d-flex flex-row p-4">
                    <Link to="/admin/tournaments" className="align-self-center idented d-flex flex-row white font-16">
                        <i className="fas fa-arrow-left margin-right align-self-center" />
                        <span className="anton align-self-center">BACK</span>
                    </Link>
                    {microTransac && <Gear className="ml-auto" />}
                    <h1 className="anton ml-auto align-self-center no-margin no-padding text-right white padding-right">TOURNAMENTS | ADD</h1>
                </div>
                <div className="h-100" style={{ position: 'relative' }}>
                    <section id="left" style={{ position: "absolute", top: 0, bottom: 0, left: 0, width: 200 }} className="">
                        <Options current={1} onLogout={this.logout} animated={false} />
                    </section>
                    <section id="left" style={{ position: "absolute", overflowY: 'auto', top: 0, bottom: 0, left: 200, right: 0 }} className="clearfix padding-right">
                        {tournament &&
                            <ScrollAnimation animateIn="fadeInRight" animateOnce={true}>
                                <figure className="card w-100 p-4">
                                    <h2 className="anton black">Basic Information</h2>
                                    <label htmlFor="name">Tournament Name</label>
                                    <input className="w-100" type="text" required ref={(i) => this.txtName = i} defaultValue={tournament.Name} />
                                    <div className="d-flex flex-row margin-top-half">
                                        <div className="w-25">
                                            <label htmlFor="name">Date Start</label>
                                            <DatePicker showYearDropdown scrollableYearDropdown yearDropdownItemNumber={15} customInput={<CustomDatePicker />}
                                                selected={moment(tournament.DateStart).utc()} startDate={moment(tournament.DateStart).utc()}
                                                onChange={this.onDateStart} />
                                        </div>
                                        <div style={{ width: 20 }} />
                                        <div className="w-25">
                                            <label htmlFor="name">Date End</label>
                                            <DatePicker showYearDropdown scrollableYearDropdown yearDropdownItemNumber={15} customInput={<CustomDatePicker />}
                                                selected={moment(tournament.DateEnd || tournament.DateStart).utc()} startDate={moment(tournament.DateEnd || tournament.DateStart).utc()}
                                                onChange={this.onDateEnd} />
                                        </div>
                                        <div style={{ width: 20 }} />
                                        <div className="w-100">
                                            <label htmlFor="name">Type</label>
                                            <div className="btn-group block">
                                                <button type="button" onClick={this.toggleSeasonType} className="btn btn-sm btn-info dropdown-toggle w-100 text-left"
                                                    data-toggle="dropdown">{tournament.IdSeasonType ? (_.find(seasonTypes, st => st.id === tournament.IdSeasonType) || {}).Name : 'Please select'}</button>
                                                <div className={`dropdown-menu ${this.state.isSeasonTypesOpen ? 'show' : ''}`}>
                                                    {seasonTypes && seasonTypes.map((st, index) => <a key={index} onClick={() => this.selectSeasonType(st)} className="dropdown-item">{st.Name}</a>)}
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ width: 20 }} />
                                        <div className="w-100">
                                            <label htmlFor="name">Affiliate</label>
                                            <div className="btn-group block">
                                                <button type="button" onClick={this.toggleAffiliates} className="btn btn-sm btn-info dropdown-toggle w-100 text-left" data-toggle="dropdown">{tournament.IdAffiliate ? (_.find(affiliates, af => af.id === tournament.IdAffiliate) || {}).Name : 'None'}</button>
                                                <div className={`dropdown-menu ${this.state.isAffiliatesOpen ? 'show' : ''}`}>
                                                    <a onClick={() => this.selectAffiliates()} className="dropdown-item">Challenge Sports</a>
                                                    {affiliates && affiliates.map((affiliate, index) => <a key={index} onClick={() => this.selectAffiliates(affiliate)} className="dropdown-item">{affiliate.Name}</a>)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-row margin-top-half">
                                        <div className="w-100">
                                            <label htmlFor="name">Location</label>
                                            <input className="w-100" type="text" required ref={(i) => this.txtLocationName = i} defaultValue={tournament.LocationName} />
                                        </div>
                                        <div style={{ width: 20 }} />
                                        <div className="w-100">
                                            <label htmlFor="name">Address</label>
                                            <input className="w-100" type="text" required ref={(i) => this.txtLocationAddress = i} defaultValue={tournament.LocationAddress} />
                                        </div>
                                    </div>
                                    <div className="d-flex flex-row margin-top-half">
                                        <div className="w-100">
                                            <label htmlFor="name">City</label>
                                            <input className="w-100" type="text" required ref={(i) => this.txtCity = i} defaultValue={tournament.LocationCity} />
                                        </div>
                                        <div style={{ width: 20 }} />
                                        <div className="w-100">
                                            <label htmlFor="name">State</label>
                                            <input className="w-100" type="text" required ref={(i) => this.txtState = i} defaultValue={tournament.LocationState} />
                                        </div>
                                        <div style={{ width: 20 }} />
                                        <div className="w-100">
                                            <label htmlFor="name">Zip Code</label>
                                            <input className="w-100" type="text" required ref={(i) => this.txtZipCode = i} defaultValue={tournament.LocationZipCode} />
                                        </div>
                                    </div>


                                    <div className="d-flex flex-row">
                                        {(!tournament.IdAffiliate || tournament.IdAffiliate === '0') && <div style={{ width: 250 }}>
                                            {/* Medal */}
                                            <h2 className="anton black margin-top" style={{ width: 250 }}>Medal</h2>
                                            <div className="margin-top d-flex flex-column">
                                                <div className="btn-group block w-100">
                                                    <button type="button" onClick={this.toggleMedal}
                                                        className="btn btn-sm btn-info dropdown-toggle w-100 text-left" data-toggle="dropdown">
                                                        {tournament.Medal ? tournament.Medal.Name : 'Select one please -if applies-'}
                                                    </button>
                                                    <div className={`dropdown-menu ${this.state.isMedalOpen ? 'show' : ''}`}>
                                                        <a className="dropdown-item w-100" onClick={() => this.selectMedal()}>- None -</a>
                                                        {medals && medals.map((medal, index) => <a key={index} className="dropdown-item" onClick={() => this.selectMedal(medal)} >{medal.Name}</a>)}
                                                    </div>
                                                </div>
                                                <div className="margin-top">
                                                    {(selectedMedal || tournament.Medal) && <Medal medal={selectedMedal || tournament.Medal} />}
                                                </div>
                                            </div>
                                        </div>
                                        }
                                        {(!tournament.IdAffiliate || tournament.IdAffiliate === '0' || (_.find(affiliates, a => a.id === tournament.IdAffiliate) || {}).UseSportslogic) === 1 && <div style={{ width: 20 }} />}
                                        <div className="w-100 pl-4">
                                            {/* Flags */}
                                            <h2 className="anton black margin-top">Flags</h2>
                                            <div className="margin-top">
                                                <div className="w-100">
                                                    <label className="d-flex flex-row">
                                                        <Switch onChange={this.toggleIsPublish} checked={tournament.IsPublic ? true : false} />
                                                        <span className="align-self-center margin-left-half">Publish</span>
                                                    </label>
                                                </div>
                                                <div className="w-100 margin-top-half">
                                                    <label className="d-flex flex-row">
                                                        <Switch onChange={this.toggleShowSchedule} checked={tournament.ShowSchedule ? true : false} />
                                                        <span className="align-self-center margin-left-half">Show Schedules</span>
                                                    </label>
                                                </div>
                                                <div className="w-100 d-flex flex-row margin-top-half">
                                                    <label className="d-flex flex-row">
                                                        <Switch onChange={this.toggleESPN} checked={tournament.IsESPN ? true : false} />
                                                        <span className="align-self-center margin-left-half">ESPN Banner</span>
                                                    </label>
                                                    <input className="margin-left-half" placeholder="Period" type="text" required ref={(i) => this.txtESPNDates = i} defaultValue={tournament.ESPNDates} />
                                                </div>
                                                {/* Suspended */}
                                                <div className="w-100 d-flex flex-row margin-top-half">
                                                    <label className="d-flex flex-row">
                                                        <Switch onChange={this.toggleSuspended} checked={tournament.Suspended ? true : false} />
                                                        <span className="align-self-center margin-left-half">Set as Postponed</span>
                                                    </label>
                                                </div>
                                                {(!tournament.IdAffiliate || tournament.IdAffiliate === '0') && <div className="w-100 d-flex flex-row margin-top-half">
                                                    <label className="d-flex flex-row">
                                                        <Switch onChange={this.toggleShirt} checked={tournament.GivesShirt ? true : false} />
                                                        <span className="align-self-center margin-left-half">Gives Shirt to Coaches</span>
                                                    </label>
                                                    <input className="margin-left-half hide" placeholder="" type="text" required ref={(i) => this.txtGamesForShirt = i} defaultValue={tournament.GamesForShirt} />
                                                </div>}
                                            </div>
                                            {(!tournament.IdAffiliate || tournament.IdAffiliate === '0' || (_.find(affiliates, a => a.id === tournament.IdAffiliate) || {}).UseSportslogic === 1) && <section><h2 className="anton black margin-top">Sports Logic</h2>
                                                <div className="margin-top">
                                                    <div className="w-100">
                                                        <label htmlFor="name">Season Id</label>
                                                        <input className="w-100" type="text" required ref={(i) => this.txtIdSeason = i} defaultValue={tournament.IdSeason} />
                                                    </div>
                                                </div>
                                            </section>}
                                        </div>
                                    </div>

                                    {(!tournament.IdAffiliate || tournament.IdAffiliate === '0') && <section>
                                        <hr />
                                        <h2 className="anton black margin-top">Rates</h2>
                                        <div className="margin-top clearfix">
                                            {tournament.Rates && tournament.Rates.map((rate, index) => <Animated key={index} animationIn="fadeIn"
                                                className="float-left w3-card hind p-2 bg-white d-flex flex-column justify-content-center margin-left-half margin-right-half"
                                                style={{ width: 140, borderRadius: 5, height: 100, position: 'relative' }}>
                                                <span className="black font-20 align-self-center toBold">{rate.Rate}</span>
                                                <span className="black font-12 align-self-center">{rate.Name}</span>
                                                <span className="black font-8 align-self-center">{rate.Dates}</span>
                                                {/*<i className="fa fa-times red pointer" onClick={() => this.deleteRate(index)} style={{ position: 'absolute', top: 5, right: 5 }} />*/}
                                            </Animated>)}
                                        </div>
                                        <span className="font-8 black block margin-top">(This section is feed directly from the Sports Logic system now, based on the Sports Logic Season Id)</span>
                                        <hr />
                                    </section>}

                                    <hr />
                                    {editorState && <section>
                                        <h2 className="anton black margin-top">Notes</h2>
                                        <figure className="w3-card pt-2 pb-2 pl-4 pr-4">
                                            <Editor
                                                ref={(i) => this.txtNotes = i}
                                                editorState={editorState}
                                                toolbarClassName="toolbarClassName"
                                                wrapperClassName="wrapperClassName"
                                                editorClassName="editorClassName"
                                                onEditorStateChange={this.onEditorStateChange}
                                                toolbar={{
                                                    options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign'],
                                                    inline: { inDropdown: false },
                                                    list: { inDropdown: true },
                                                    textAlign: { inDropdown: false },
                                                    fontFamily: { options: ['Hind', 'Anton'] },
                                                }}
                                            />

                                            <div className="w-100">
                                                <label className="d-flex flex-row">
                                                    <Switch onChange={this.toggleShowNotes} checked={tournament.ShowNotes ? true : false} />
                                                    <span className="align-self-center margin-left-half">Show Notes</span>
                                                </label>
                                            </div>
                                        </figure>
                                    </section>}

                                    <hr />

                                    <section>
                                        {/* HOTELS */}
                                        <h2 className="anton black margin-top">Hotels</h2>
                                        {tournament && !tournament.IdSeason && <span className="font-10 black">*Sports Logic Season Id required</span>}
                                        <div className="margin-top d-flex flex-row">

                                            <div className="hind py-0 pl-0 pr-4 w-25" style={{ borderRadius: 5, maxWidth: 300 }}>
                                                <div className="w-100">
                                                    <div className="btn-group block">
                                                        <button type="button" onClick={() => this.setState({ isHotelsOpen: !this.state.isHotelsOpen })} className="btn btn-info dropdown-toggle w-100 text-left" data-toggle="dropdown">{this.state.selectedHotel ? this.state.selectedHotel.HotelName : 'Pick Hotel'}</button>
                                                        <div className={`dropdown-menu ${this.state.isHotelsOpen ? 'show' : ''}`}>
                                                            {hotels && hotels.map((hotel, index) => <a key={index} onClick={() => this.setState({ selectedHotel: hotel, isHotelsOpen: false })} className="dropdown-item">{hotel.HotelName}</a>)}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="w-100">
                                                    <input placeholder="Rate (*)" className="w-100" type="text" required ref={(i) => this.txtRateHotel = i} />
                                                </div>
                                                <div className="d-flex flex-row">
                                                    <button onClick={this.addHotel} className="btn btn-info block w-100 h-auto">
                                                        <i className="fa fa-plus margin-right-half" /> Add Hotel</button>
                                                </div>
                                            </div>

                                            <div className="w-75 d-flex flex-wrap">
                                                {tournament.Hotels && tournament.Hotels.map((hotel, index) => <Animated key={index} animationIn="fadeIn"
                                                    className=" w3-card hind p-3 bg-white d-flex flex-row w-50"
                                                    style={{ borderRadius: 5, position: 'relative' }}>
                                                    <div className="w-25">
                                                        <img src={hotel.HotelLogo} alt="" className="w-100" />
                                                    </div>
                                                    <div className="d-flex flex-column w-75 px-3">
                                                        <div className="w-100 text-right">
                                                            <i className="fa fa-times red pointer" onClick={() => this.deleteHotel(index)} />
                                                        </div>
                                                        <div>
                                                            <span className="black font-20 align-self-center toBold line1">{hotel.HotelName}</span>
                                                        </div>
                                                        <div>
                                                            <span className="black font-12 align-self-center">{hotel.Rate || hotel.Price}</span>
                                                        </div>
                                                        <div className="mt-auto text-right">
                                                            <button className='mx-auto btn btn-link' onClick={() => {
                                                                const { tournament } = this.state;
                                                                tournament.Hotels[index].IsHost = !tournament.Hotels[index].IsHost;
                                                                this.setState({ tournament }, () => {
                                                                    this.MarkHost(tournament.Hotels[index]);
                                                                });
                                                            }}><i className={`${!hotel.IsHost ? `far fa-square` : `fas fa-square-check fa-check-square green`} mr-2`}></i>Host</button>
                                                        </div>
                                                    </div>
                                                </Animated>)}
                                            </div>
                                        </div>
                                    </section>
                                    <div className="d-flex flex-row margin-top">
                                        {tournament.id && <button id="btn-delete" onClick={this.toggleDelete} type="button" style={{ width: 100 }} className="align-self-center btn-red text-center">REMOVE</button>}
                                        <Link to="/admin/tournaments" className="align-self-center btn-link text-center ml-auto margin-right black">CANCEL</Link>
                                        <button onClick={this.save} type="submit" style={{ width: 100 }} className="align-self-center btn-white text-center">SAVE</button>
                                    </div>
                                    {tournament.id && <Popover placement="bottom" isOpen={this.state.deleting} target={`btn-delete`} toggle={this.toggleDelete}>
                                        <PopoverHeader>Are you sure?</PopoverHeader>
                                        <PopoverBody className="d-flex flex-row justify-content-center">
                                            <button className="btn btn-success btn-sm" onClick={this.doDelete}>Yes, Delete it</button>
                                            <button className="btn btn-danger btn-sm" onClick={this.toggleDelete}>No, Cancel</button>
                                        </PopoverBody>
                                    </Popover>}
                                </figure>
                            </ScrollAnimation>}
                    </section>
                </div>
            </section>
        )
    }
}

export default AddTournament;



// WEBPACK FOOTER //
// ./src/components/private/tournaments/add.js